export default "__VITE_ASSET__CS6P0sI___"